module.exports = __webpack_public_path__ + "img/circle-question-solid-full.e4fbd226.png";